module.exports = __webpack_public_path__ + "img/heguihefa-sp.98d0ca8b.png";